import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const moreSection = css`
  margin: ${size[60]} auto;
  max-width: ${width.container.large};

  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-size: ${pxToRem(28)};
    margin-bottom: ${size[20]};
    text-align: center;
  }

  ${breakpoint.up('md')} {
    flex-direction: row;
    justify-content: center;
    gap: ${size[32]};

    h3 {
      margin-bottom: 0;
      margin-right: ${size[20]};
      text-align: left;
    }
  }
`

export const left = css`
  align-items: flex-start;

  ${breakpoint.up('md')} {
    align-items: center;
    justify-content: flex-start;
  }
`

export const center = css`
  align-items: center;
  padding: 0 ${size[20]};

  ${breakpoint.up('md')} {
    justify-content: center;
  }
`

export const right = css`
  align-items: flex-end;

  ${breakpoint.up('md')} {
    align-items: center;
    justify-content: flex-end;
  }
`

export const cta = css`
  padding: ${size[16]} ${size[48]};
  flex-shrink: 0;

  span {
    white-space: nowrap;
  }
`
